import { Fragment } from "react";
import Avatar from "@mui/material/Avatar";

type PropsAvatar = {
  src?: string | null;
  size?: string | number;
  name: string;
};

const ProfileAvatar = ({ name = "", size = "", src = null }: PropsAvatar) => {
  function stringAvatar(name: string, size: string | number) {
    const nameInitials = `${name.charAt(0)}`;
    return {
      sx: {
        bgcolor: "#1CB1B1",
        fontFamily: "Jost",
        width: size,
        height: size,
      },
      children: nameInitials.toUpperCase(),
    };
  }

  return (
    <Fragment>
      {src ? (
        <Avatar alt={name} src={src} sx={{ width: size, height: size }} />
      ) : (
        <Avatar {...stringAvatar(name, size)} />
      )}
    </Fragment>
  );
};

export default ProfileAvatar;
